export const statusOptions = [
  { value: "all", label: "All Systems" },
  { value: "up", label: "Up" },
  { value: "down", label: "Down" },
  { value: "paused", label: "Paused" },
];
